import { render, staticRenderFns } from "./hotelBooking.vue?vue&type=template&id=348450dc"
import script from "./hotelBooking.vue?vue&type=script&lang=js"
export * from "./hotelBooking.vue?vue&type=script&lang=js"
import style0 from "./hotelBooking.vue?vue&type=style&index=0&id=348450dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports